module.exports = __webpack_public_path__ + "img/emailEle.6bdb7f80.svg";